module.exports = __webpack_public_path__ + "media/src/images/icon__sad--0-ef40b0324ee2f247df51d5fd535076bd.png";